/* Based on: https://stackoverflow.com/questions/14046481/looping-through-elements-data-attributes */
export function getAllDataset($el) {
    const dataset = {};

    // Cycle over each attribute on the element
    for (let i = 0, len = $el.attributes.length; i < len; i++) {
        // Store reference to current attr
        const attr = $el.attributes[i];

        // If attribute nodeName starts with 'data-'
        if (/^data-/.test(attr.nodeName)) {
            const key = attr.nodeName.replace(/^data-/, '');
            dataset[key] = attr.nodeValue;
        }
    }

    return dataset;
}